import script from "./WhoBenefitsList.vue?vue&type=script&setup=true&lang=js"
export * from "./WhoBenefitsList.vue?vue&type=script&setup=true&lang=js"

import "./WhoBenefitsList.vue?vue&type=style&index=0&id=069a4d43&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-069a4d43"]])

export default __exports__